import classNames from 'classnames';
import { Component } from 'react';

import { dateFormat, timeFormat } from 'common/helpers/dateHelper';
import { getCurrency } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

class ReservationSummaryReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReservationSummary: false
    };
  }

  handleToggleReservationSummary = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      showReservationSummary: !prevState.showReservationSummary
    }));
  };

  render() {
    const { reservation, settings } = this.props;
    const { showReservationSummary } = this.state;
    const item = {
      price: reservation.price,
      itemData: reservation.additionalInfo
    };

    if (reservation.virtualCart) {
      item.price = reservation.virtualCart.items[0].price;
      item.comparePrice = reservation.virtualCart.items[0].comparePrice;
    }
    return (
      <>
        <div className="c7-checkout-template__toggle">
          <div>
            <a onClick={this.handleToggleReservationSummary}>
              <span>Reservation No. {reservation.reservationNumber}</span>
            </a>
          </div>
        </div>

        <section
          className={classNames(
            'c7-checkout-summary',
            showReservationSummary && 'c7-visible'
          )}
        >
          <div className="c7-cart-summary">
            <strong>
              {reservation.reservationType && reservation.reservationType.title}
            </strong>
            <br />
            {reservation.reservationTypeOption &&
              reservation.reservationTypeOption.title}
            <br />
            {dateFormat(reservation.reservationDate, settings)}{' '}
            {timeFormat(reservation.reservationDate, settings)}
            <br />
            <div>
              <div>{reservation.guestCount} Guest(s): </div>
              <div>
                <ItemPrice settings={settings} item={item} />
              </div>
            </div>
            <div className="c7-cart-summary__total">
              <div>Subtotal:</div>
              <div>
                <span>{getCurrency(settings)}</span>{' '}
                {currencyFormat(item.price * reservation.guestCount, settings)}
                <PointsSummary item={item} reservation={reservation} />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const ItemPrice = (props) => {
  const { item, settings } = props;
  if (item.comparePrice > item.price) {
    return (
      <>
        <span className="c7-checkout-summary__strikethrough">
          {currencyFormat(item.comparePrice, settings)}
        </span>
        {currencyFormat(item.price, settings)} / person
        <Points item={item} />
      </>
    );
  }
  return (
    <>
      {currencyFormat(item.price, settings)} / person <Points item={item} />
    </>
  );
};

const Points = (props) => {
  const { item } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        <span>&nbsp;</span>
        {item.itemData.loyaltyPoints} Points
      </>
    );
  }
  return null;
};

const PointsSummary = (props) => {
  const { item, reservation } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        <span>&nbsp;</span>
        {item.itemData.loyaltyPoints * reservation.guestCount} Points
      </>
    );
  }
  return null;
};

export default ReservationSummaryReceipt;
